module.exports = __webpack_public_path__ + "static/media/the_foods_that_reverse_climate_change_desktop.9c84ccf1.png";